import { Component } from '@angular/core';
import { Animations, StandardBeitragComponent, } from '@vhv/tarifrechner-common';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: './cyber-sicherheitsvorkehrungen.component.html',
})

export class CyberSicherheitsvorkehrungenComponent extends StandardBeitragComponent {


    initialiseSeite() {
        super.initialiseSeite();

        this.setOberflaecheElemente();
    }

    onSubmit(): void {
        super.onSubmit();
    }


    private setOberflaecheElemente() {
        for (const element of this.currentSeite.elemente) {
            if (element.value == '') {
                // Der Wert ist vor dem betreten der Seite auf "", da der Preisvorschlag diese Fragen dann mit "n/a"
                // beantwortet. Erst beim betreten der Seite sollen die Checkboxen einen validen Wert bekommen, da sonst
                // falschangaben im PDF angedruckt werden.
                // Der Wert kann false sein und wird  durch die Checkbox auch als bool gesetzt.
                // @ts-ignore
                element.value = false;
            }
        }
    }

}
